import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'
import ListsRepository from '@/libs/customAxios/listsAxios'
// import DashboardRepository from '@/libs/customAxios/dashboardAxios'
import ReportRepository from '@/libs/customAxios/reportsAxios'

const resource = '/merchant/order'
const defaultPagination = 20

export default {
  getOrderList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}?page=${pageNumber}&${filterQuery}&paginate=${pagination}&sort=-id`)
  },
  getOrderListNoPagination(filterQuery) {
    return Repository.get(`${resource}?&${filterQuery}&sort=-id&noPagination`)
  },
  getOrderListQueue(filterQuery) {
    return Repository.post(`${resource}/queue/all-order-excel-download?${filterQuery}`)
  },
  getOrderListbyKey(pageNumber = 1, key, filterQuery, pagination = defaultPagination) {
    return OperationRepository.get(`${resource}?page=${pageNumber}&filter[status]=${key}&${filterQuery}&paginate=${pagination}&sort=-id`)
  },
  getOrderListbyKeyNoPagination(key, filterQuery) {
    return Repository.get(`${resource}?filter[status]=${key}&${filterQuery}&sort=-id&noPagination`)
  },
  getOrderDetails(id) {
    return OperationRepository.get(`${resource}/${id}`)
  },
  fetchOrderDetailsById(id) {
    return Repository.get(`${resource}/order-details/${id}`)
  },
  getOrderTimeLine(id) {
    return OperationRepository.get(`${resource}/${id}/time-line`)
  },
  getOrderInvoiceTimeLine(id) {
    return OperationRepository.get(`${resource}/${id}/invoice-time-line`)
  },
  getOrderSummery() {
    return ReportRepository.get(`${resource}/summery`)
  },
  getOrderStatusList() {
    return OperationRepository.get(`${resource}/status-list`)
  },
  getNonPickupRequestOrderCount() {
    return Repository.get(`${resource}/non-pickup-request-count`)
  },
  createSingleOrder(payload) {
    return OperationRepository.post(`${resource}/single`, payload)
  },
  createBulkOrder(payload) {
    return OperationRepository.post(`${resource}/bulk`, payload)
  },
  createBulkExcelOrder(payload) {
    return OperationRepository.post(`${resource}/bulk-excel`, payload)
  },
  deleteOrder(payload) {
    return Repository.delete(`${resource}/bulk-destroy`, {
      params: {
        waybill_numbers: payload,
      },
    })
  },

  getKeyListForOrders(paylaod) {
    return Repository.get(`${resource}/order-status-key`, {
      params: {
        waybills: paylaod,
      },
    })
  },

  getStatusList() {
    return Repository.get('/merchant/status/merchant')
  },
  getOrderListByKey(key, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ListsRepository.get(`/merchant/order/operation?status_key=${key}&paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=-id`)
  },
  getOrderListByKeyNoPagination(key, filterQuery) {
    return Repository.get(`/merchant/order/operation?status_key=${key}&${filterQuery}&sort=-id&noPagination`)
  },
  fetchOrderListByKey(key, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return ListsRepository.get(`/merchant/order/operation/fetch-data?status_key=${key}&paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=-id`)
  },
  fetchOrderListByKeyNoPagination(key, filterQuery) {
    return Repository.get(`/merchant/order/operation/fetch-data?status_key=${key}&${filterQuery}&sort=-id&noPagination`)
  },
  updateOrderStatus(payload) {
    return OperationRepository.post('/merchant/order/status-update', payload)
  },
  getPODOrdersByWaybill(waybill) {
    return Repository.get(`/merchant/order/${waybill}/print-pod`)
  },
  getPODOrdersByWaybills(waybills) {
    return Repository.get('/merchant/order/print-pod-bulk', {
      params: {
        waybill_number: waybills,
      },
    })
  },
  getOrderFlagDetailsById(id) {
    return OperationRepository.get(`/merchant/order/${id}/flag`)
  },

  editDraftOrder(payload) {
    return Repository.put('/merchant/order/draft-edit', payload)
  },
  getOrderDetailsByWaybill(waybill) {
    return Repository.get(`${resource}/waybill/${waybill}`)
  },
  getFlagDropdownByStatus(status) {
    return ListsRepository.get(`/merchant/flag-dropdown-list?status_key=${status}`)
  },
  getAssignedRedeliveryFlagCount(id) {
    return Repository.get(`${resource}/${id}/redelivery-flag-count`)
  },
  getOrderEditLogTimeline(id) {
    return Repository.get(`/admin/order/${id}/edit-logs`)
  },
  getOrderRemarkTimeLine(id) {
    return Repository.get(`${resource}/${id}/remark-time-line`)
  },
  getOrderFlagTimeLine(id) {
    return Repository.get(`${resource}/${id}/flag-time-line`)
  },
}
